function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { Box } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { useIsomorphicLayoutEffect } from "../hooks";
const Img = styled(Box)`
  max-width: 100%;
  border-radius: inherit;

  opacity: 0;

  ${({ lazy  })=>lazy && css`
      opacity: 1;
      transition: opacity 0.2s ease-in;
    `}

  ${({ loaded  })=>loaded && css`
      opacity: 1;
    `}
`;
const Image = (props)=>{
    const { width , height , src  } = props, rest = _objectWithoutProperties(props, [
        "width",
        "height",
        "src"
    ]);
    const [loaded, setLoaded] = useState(false);
    const [lazy, setLazy] = useState(false);
    const imgRef = useRef(null);
    useIsomorphicLayoutEffect(()=>{
        if (src) {
            const img = new window.Image();
            img.src = src;
            if (img.complete) setLoaded(true);
        }
    }, [
        src
    ]);
    const loadedRef = useRef(loaded);
    useEffect(()=>{
        loadedRef.current = loaded;
    }, [
        loaded
    ]);
    const handleLoad = useCallback(()=>{
        if (loadedRef.current) return;
        setLazy(true);
    }, []);
    return /*#__PURE__*/ _jsx(Img, _objectSpread({
        as: "img",
        ref: imgRef,
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img
        loading: "lazy",
        decoding: "async",
        onLoad: handleLoad,
        // native `width` and `height`
        src: src,
        width: width,
        height: height || "auto",
        loaded: loaded,
        lazy: lazy
    }, rest));
};
export default Image;
